import { PUBMED_CITATION_BUNDLE } from "@/graphql/pubmed.graphql";
import { useLazyQuery } from "@apollo/react-hooks";

const usePaperCitation = (doi: string) => {
  const [loadCitation, { called, loading, data }] = useLazyQuery(
    PUBMED_CITATION_BUNDLE,
    {
      variables: { doi },
    }
  );
  return {
    loadCitation,
    loading,
    data,
    called,
  };
};
export default usePaperCitation;
